

export default {
components: {},
methods: {
jump: function (e) {
this.$router.push(e);
}
},
data() {
return {
IntroduceInfo:[],
Content:"",
Keyword:[]
}
},
created() {

this.$tyh.GetCourse(this.$route.params.IDCode)
.then((data) => {
this.IntroduceInfo =data.data.Data.course;

this.Content=data.data.Data.course.Content;

var keyword = data.data.Data.course.Keyword;
if(keyword){
this.Keyword=keyword.split("|");
}

});
},
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Introduce.vue